     
export default function()
{
    return[
        {name:'Projets', content:4, type:'entier', fa:'fa-hand-peace-o', id:1},
        {name:'Employés', content:6, type:'entier',fa:'fa-id-badge', id:2},
        {name:'Happy clients', content:1300, type:'entier',fa:'fa-users', id:3},
        {name:'Existence (jrs)', content:'14/09/2018', type:'date',fa:'fa-heartbeat', id:4}
    ]
}